import mqtt from 'mqtt/dist/mqtt'

const state = {
  timer:null,
  life:{},
  connection: {
    clean: true, // Reserved session
    connectTimeout: 4000, // Time out
    reconnectPeriod: 4000, // Reconnection interval
  },
  client: {
    connected: false,
  },
  subscription: {
    topic: '',
    qos: 0,
  },
  subscriptions:[],
}
const mutations = {

}
const getters = {

}
const actions = {
  loadReceta({state},datos){
    this.dispatch('nodered/doPublish',
    {topic:process.env.VUE_APP_TOPIC_TRAMOS,'payload': JSON.stringify( datos)})
  },

  miFuncion({state}){
    console.log("nodered life")
  },
  createConnection({state,commit,rootState}) {
    const {  ...options } = state.connection
    const protocolo = window.location.protocol.includes('https')? 'wss':'ws';
    // const protocolo = 'wss';
    const connectUrl = `${protocolo}://${window.location.hostname}:${process.env.VUE_APP_MQTT_PORT}`
    // const connectUrl = `${protocolo}://aceros.koiote.es:${process.env.VUE_APP_MQTT_PORT}`
    console.log("creando conexion en",connectUrl)
    try {
      state.client = mqtt.connect(connectUrl, options)
    } catch (error) {
      console.log('mqtt.connect error', error)
    }

    this.dispatch('mensajes/setCliente',state.client)

   
  },
   //Solicita al node-red cliente que le traiga todos los datos anteriores
   doPublish({state},publication) {
    if(publication.topic == 'TRAER_CICLO_1') console.log("TRAYENDO CICLO ACTUAL");
    const { topic, qos, payload } = publication
    console.log('doPublish',topic, qos, payload )

    state.client.publish(topic, payload, qos, error => {
      if (error) {
        console.log('Publish error', error)
      }
    })
  },
  doSubscribe({state},topic) {
    console.log(`quiere suscibirse a ${topic}`)
     const { qos } = state.subscription
     state.client.subscribe(topic, { qos }, (error, res) => {
       if (error) {
         console.log('Subscribe to topics error', error)
         return
       }
      state.subscriptions.push(topic)

       })
   },
}
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}